import React, { useState, useEffect } from "react";
import _ from "i18n";

const FeedMangoModalFooter = ({ step, amount, payinType, tag, changeStep }) => {


  const handlePreviousClick = () => {
    changeStep(step - 1);
  };

  const handleNextClick = () => {
    changeStep(step + 1);
  };

    if(step === -1)
      return(
        <div className={'flex'}>
          <button type={'button'}
                  className="partial-credit-note-cancel-button"
                  onClick={handleNextClick} style={{'width': '100px'}}>{_("previous")}</button>
        </div>
      );

    if(payinType === "CARD")
      return(
        <div className={'flex'}>
          <button type={'button'}
                  className="partial-credit-note-cancel-button"
                  onClick={handlePreviousClick}
                  style={{'width': '100px'}}>{_("previous")}</button>
          {
            step === 1 &&
            <button type={'button'}
                    className="partial-credit-note-save-button ml-auto"
                    onClick={handleNextClick} style={{'width': '100px'}}
                    disabled={!amount}>{_("next")}</button>
          }
        </div>
      );


    return (
      <div className={'flex'}>
        {
          (step === 1 || step === 2) &&
          <button type={'button'}
                  className="partial-credit-note-cancel-button"
                  onClick={handlePreviousClick}
                  style={{'width': '100px'}}>{_("previous")}</button>
        }
        {
          step === 1 &&
          <button type={'button'}
                  className="partial-credit-note-save-button ml-auto"
                  onClick={handleNextClick} style={{'width': '100px'}}
                  disabled={!amount}>{_("next")}</button>
        }
        {
          step === 2 &&
          <button type={'button'}
                  className="partial-credit-note-save-button ml-auto"
                  onClick={handleNextClick} style={{'width': '100px'}}
                  disabled={!tag}>{_("next")}</button>
        }
      </div>
    );

}

export default FeedMangoModalFooter;





// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/FeedMangoModalFooter.js